import AppBtnShare from '../app-btn-share'
import AppImgBg from '../app-img-bg'
import AppTextMask from '../app-text-mask'

// URL list
import URL from '../../../config.url'

export default
{
    name: 'app-news-slideshow',

    components:
    {
        AppBtnShare,
        AppImgBg,
        AppTextMask
    },

    watch:
    {
        contentPage: '_sortNews'
    },

    props:
    {
        news: { type: Array, default: [] },
        share: { type: Object, default: {} },
        footer: { type: String, default: 'Read more' }
    },

    data()
    {
        return {
            activeIndex: 0
        }
    },

    created()
    {
        this.SLIDE_DURATION = 10000 // in ms
        this.duration = {
            slide: 0,
            start: new Date().getTime(),
            current: null,
            pause: {
                start: null,
                paused: false,
                elapsed: [],
                allElapsed: 0,
                index: 0
            }
        }

        this.eventHub.$on('application:on-frame', this.onFrame)
    },

    mounted()
    {
        this.$progressBars = this.$el.querySelectorAll('.js-progress')
    },

    destroyed()
    {
        this.eventHub.$off('application:on-frame', this.onFrame)
    },

    methods:
    {
        // EVENTS
        onFrame()
        {
            if (this.$progressBars && this.$root.width > 940 && !this.duration.pause.paused)
            {
                this.duration.current = new Date().getTime()
                this.duration.slide = this.duration.current - (this.duration.start + this.duration.pause.allElapsed)

                if (this.duration.slide >= this.SLIDE_DURATION)
                {
                    this.resetDuration()

                    if (this.activeIndex === this.news.length - 1)
                    {
                        this.activeIndex = 0
                    }
                    else
                    {
                        this.activeIndex += 1
                    }
                }

                this.$progressBars.forEach((bar, index) =>
                {
                    if (index === this.activeIndex)
                    {
                        bar.style.transform = `scaleX(${Math.round((this.duration.slide / this.SLIDE_DURATION) * 1000) / 1000}) translateZ(0)`
                    }
                    else
                    {
                        bar.style.transform = 'scaleX(0) translateZ(0)'
                    }
                })
            }
            else if (this.$progressBars && this.$root.width > 940 && this.duration.pause.paused)
            {
                if (!this.duration.pause.elapsed[this.duration.pause.index])
                {
                    this.duration.pause.elapsed[this.duration.pause.index] = 0
                }

                this.duration.pause.elapsed[this.duration.pause.index] = new Date().getTime() - this.duration.pause.start

                this.duration.pause.allElapsed = this.duration.pause.elapsed.reduce((acc, val) => acc + val)
            }
        },

        resetDuration()
        {
            this.duration.start = this.duration.current

            this.duration.pause.start = null
            this.duration.pause.elapsed = []
            this.duration.pause.allElapsed = 0
            this.duration.pause.index = 0
            this.duration.pause.paused = false

            this.duration.slide = 0
        },

        // HTML ACTIONS
        changeActiveIndexTo(index)
        {
            this.resetDuration()

            this.activeIndex = index
        },

        clickOnNews(slug)
        {
            this.$router.push(this.getArticleUrlBySlug(slug))
        },

        _shorten(text, length)
        {
            if (text.length > length - 3)
            {
                text = text.substr(0, length - 3)
                text = text.substr(0, Math.min(text.length, text.lastIndexOf(' '))) + '...'
            }

            return text
        },

        getArticleUrlBySlug(slug)
        {
            return this.$root.getPageURLFromID('article').replace(':slug', slug)
        },

        _pauseSlideshow()
        {
            this.duration.pause.start = new Date().getTime()
            this.duration.pause.paused = true
        },

        _resumeSlideshow()
        {
            this.duration.pause.start = null
            this.duration.pause.index += 1
            this.duration.pause.paused = false
        }
    }
}



// WEBPACK FOOTER //
// ./src/scripts/components/app-news-slideshow/script.js